import { render } from "./tabla.vue?vue&type=template&id=bc6b4bd0&scoped=true"
import script from "./tabla.vue?vue&type=script&lang=js"
export * from "./tabla.vue?vue&type=script&lang=js"

import "./tabla.vue?vue&type=style&index=0&id=bc6b4bd0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bc6b4bd0"

export default script